module.exports = __webpack_public_path__ + "static/media/10d.ec256988.png";